import * as React from 'react';

interface IRefWrapperProps {
  children: React.ReactNode | React.ReactNode[];
  ref?: React.Ref<HTMLDivElement>;
}

export function RefWrapper({ children, ref }: IRefWrapperProps): React.JSX.Element {
  return <div ref={ref}>{children}</div>;
}
